import { NgModule } from '@angular/core';
import { SubscriptionButtonComponent } from './subscription-button.component';

@NgModule({
  imports: [SubscriptionButtonComponent],
  exports: [SubscriptionButtonComponent]
})
export class SubscriptionButtonModule {}
